import {ModalProps} from "react-bootstrap/Modal";
import {Modal} from "react-bootstrap";
import React, {memo, useEffect} from "react";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions} from "../../store/sliceApp";

const ModalSuccess= (props: ModalProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const {text, onHide, show} = props
    useEffect(() => {
        dispatch(actions.hideLoading())
    },[props.text])

    useEffect(() => {
        setInterval(() => {
            if (onHide) {
                onHide();
            }
        }, 3000);
    }, [show])

    return (
        <Modal
            {...props}
            size={"sm"}
        //    centered
        >
            {/*<Modal.Header closeButton>*/}
            {/*    Сообщение*/}
            {/*</Modal.Header>*/}
            <Modal.Body>
                <p style={{color: "green", justifySelf: "center", margin: 0}}>
                    {text}
                </p>
            </Modal.Body>
        </Modal>
    );
}

export default memo(ModalSuccess)
